export default "__VITE_ASSET__DGajNCWT__"